import * as shape from 'd3-shape'

import fromBar from './from-bar-animation'
import fromLine from './from-line-animation'
import fromPie from './from-pie-animation'
import removeInnerStack from './remove-inner-stack-animation'
import addInnerStack from './add-inner-stack-animation'
import splitArea from './split-area-animation'
import unsplitArea from './unsplit-areas-animation'
import addBreakdown from './add-breakdown-animation'
import removeBreakdown from './remove-breakdown-animation'
import sliding from './sliding-animation'
import enteringStacked from './entering-stacked-animation'
import exitingStacked from './exiting-stacked-animation'
import entering from './entering-animation'
import exiting from './exiting-animation'
import basic from './basic-animation'

const Animations = [
  fromBar,
  fromLine,
  fromPie,
  removeInnerStack,
  addInnerStack,
  splitArea,
  unsplitArea,
  addBreakdown,
  removeBreakdown,
  sliding,
  enteringStacked,
  exitingStacked,
  entering,
  exiting,
  basic
]

Animations.forEach(Animation => {

  let configure = Animation.prototype.configure

  Animation.prototype.configure = function (axis, serie) {
    this.curve = shape.curveMonotoneX // smooth curve for filled (area) graphs
    this.filled = true
    return configure.apply(this, arguments)
  }
})

export default Animations
